<template>
    <div class="subdescript">
        <div class="description-short" v-show="!toggle">
            <p class="max-show" v-html="description.replace(/\n/g,'<br>')"></p>
        </div>
        <div class="description-long" v-show="toggle">
            <p class="max-hide" v-html="description.replace(/\n/g,'<br>')"></p>
        </div>
        <div v-if="is_indicate_toggle" class="toggle" :class="{ 'is-active': toggle }" @click="toggle = !toggle">
            <span class="c-link-text" v-if="toggle">折りたたむ</span>
            <span class="c-link-text" v-else>続きを読む</span>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'description',
    ],
    data() {
        return {
            toggle: false,
            is_indicate_toggle: false,
        }
    },
    mounted () {
        this.is_indicate_toggle = this.isIndicateToggle();
    },
    methods: {
        // 説明文が長い場合に「続きを読む」を表示するかを判定するメソッド
        // .description < .max-showの場合は true (表示する)
        isIndicateToggle: function() {
            // 比較対象のelement取得
            let element = this.$el;
            let descriptionElement = element.querySelector('.description-short');
            let maxShowElement = element.querySelector('.max-show');
            // 比較 「続きを読む」が必要な場合はtrue
            if (descriptionElement.clientHeight < maxShowElement.clientHeight) {
                return true;
            }
            return false;
        }
    },
}
</script>

<style lang="scss" scoped>
    .description-short {
        overflow: hidden;
        height: 6em;
    }

    .subdescript div.toggle span::before, .subdescript div.toggle span::after  {
        border-color: #039BE5 transparent transparent transparent;
    }

    .subdescript div.toggle.is-active span::after  {
        border-color: transparent transparent #039BE5 transparent;
    }
</style>